import * as React from "react";
import { Add } from "@mui/icons-material";
import { SubTransactionForm } from "./SubTransactionForm";
import { ISubTransaction } from "./SubTransactionsField";

interface IDeleteActionProps {
    onChange(value: ISubTransaction): void;
}

export const AddAction = ({onChange}: IDeleteActionProps) => {
    return (
        <SubTransactionForm
            title="Add new sub transaction"
            onChange={onChange}
            trigger={<Add sx={{fontSize: 18}} />}
        />
    );    
};
